import { useEffect, useState } from "react";
import { createUseStyles } from "react-jss";

import widgets from "styles/widgets";
import { UserDto } from "dtos/user.dto";
import displayStyles from "styles/display-styles";
import { TemplateDto } from "dtos/shard/template.dto";

import TemplateView from "../views/template-view";
import TemplateEditor from "../editors/template-editor";
import { statsPanel, toggleStatsPanel } from "utils";

const styles = createUseStyles({});

export default function TemplateDisplay(props: {
    user?: UserDto, // Optional dto of the user.
    className?: string, // Optional css class name to use.
    template?: Partial<TemplateDto>, // The template dto to display, if undefined a blank template will be displayed instead.
    onSave?: (template: TemplateDto) => void, // A function to call when created or updated.
    onClose?: () => void, // A function to call when the close button is clicked, if not set the close button is hidden.
}): JSX.Element
{
    // States:
    const [stats, setStats] = useState(statsPanel());
    const [templatePreview, setTemplatePreview] = useState(props.template);

    // Effects:
    useEffect(() => {
        setTemplatePreview(props.template);
    }, [props.template]);

    // Styles:
    const widgetClasses = widgets();
    const displayClasses = displayStyles();
    const classes = styles();

    // Components:
    let statsComp: JSX.Element | undefined;
    if (stats) {
        // Template Stats (Editor for Admins):
        if (props.user?.super) {
            statsComp = (
                <div className={`${displayClasses.stats}`}>
                    <div className={`${displayClasses.editor}`}>
                        <h3>Editor:</h3>
                        <TemplateEditor
                            user={props.user}
                            template={props.template}
                            preview={templatePreview}
                            onPreviewUpdate={setTemplatePreview}
                            onSave={props.onSave}
                            onClose={props.onClose}
                        />
                    </div>
                </div>
            );
        } else {
            statsComp = (
                <div className={`${displayClasses.stats}`}>
                    <div className={`${widgetClasses.column}`}>
                        <h3>Stats:</h3>
                        <ul>
                            <li>Name: {props.template?.name}</li>
                        </ul>
                    </div>
                </div>
            );
        }
    }

    // Return Component:
    return (
        <div className={`${displayClasses.container} ${props.className ?? ""}`}>
            <div className={`${displayClasses.controls}`}>
                <div className={`${displayClasses.button} ${statsPanel() ? displayClasses.buttonActive : ""}`} onClick={() => setStats(toggleStatsPanel())}>
                    <div className={`${displayClasses.icon} ${displayClasses.iconStats}`}></div>
                </div>
                {props.onClose && <div className={`${displayClasses.button}`} onClick={() => props.onClose!()}>
                    <div className={`${displayClasses.icon} ${displayClasses.iconClose}`}></div>
                </div>}
            </div>
            <TemplateView template={templatePreview} />
            {statsComp}
        </div>
    );
}
